import Logo from "../assets/images/logo_white.png";
import { FaInfoCircle } from "react-icons/fa";
import { MdOutlineWork } from "react-icons/md";
import { MdOutlineExplore } from "react-icons/md";
import { BsFillQuestionSquareFill } from "react-icons/bs";
import { IoMdMail } from "react-icons/io";
import { FaSchool } from "react-icons/fa";
import { MdFlight } from "react-icons/md";

export const COMPANY_DATA = {
  services: [{ title: "", description: "" }],
  name: "Renpha Consulting",
  logo: Logo,
  phones: ["+234(0)8142914658"],
  emails: ["renphaconsulting@gmail.com"],
  addresses: [
    {
      name: "8, Layi Oyekanmi Street, Mushin, Lagos State, Nigeria",
      lat: 0,
      lng: 0,
    },
  ],
  shortAbout:
    "RENPHA CONSULTING is a registered company with the Corporate Affairs Commission both locally and internationally accredited & licensed by travel & tourism governing bodies to operate haven met all the necessary requirements and standards.",
  longAbout: "",
  CLIENTELE: [
    { name: "", company: "", position: "", comment: "" },
    { name: "", company: "", position: "", comment: "" },
    { name: "", company: "", position: "", comment: "" },
    { name: "", company: "", position: "", comment: "" },
  ],
};

export const SECTIONS = [
  { text: "About", icon: FaInfoCircle, to: "#about" },
  { text: "Services", icon: MdOutlineWork, to: "#services" },
  { text: "Schools", icon: FaSchool, to: "#schools" },
  { text: "Destinations", icon: MdFlight, to: "#destinations" },
  { text: "Contact Us", icon: IoMdMail, to: "#contact-us" },
  { text: "FAQs", icon: BsFillQuestionSquareFill, to: "#faqs" },
];
